// 亮度字号——主流程
const MainRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `size/index${i + 1}`,
  name: `sizeIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/size/index${i + 1}.vue`)
}))
const BranchRoutes = Array.from({ length: 4 }, (_, i) => ({
  path: `size/branch/index${i + 1}`,
  name: `sizeBranchIndex${i + 1}`,
  component: () => import(`@/views/phoneSettings/size/branch/index${i + 1}.vue`)
}))



export default {
  path: '/phoneSettings',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 亮度字号——主流程，开始
    ...MainRoutes,
    // 亮度字号——分支流程，开始
    ...BranchRoutes,


  ],
};
